/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {any}
     * @memberof HTTPValidationError
     */
    'detail'?: any;
}
/**
 * 
 * @export
 * @interface SendSessionApplicationAcceptedInput
 */
export interface SendSessionApplicationAcceptedInput {
    /**
     * List of user IDs to send session application accepted notification to
     * @type {any}
     * @memberof SendSessionApplicationAcceptedInput
     */
    'user_ids': any;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {any}
     * @memberof SendSessionApplicationAcceptedInput
     */
    'session_id': any;
}
/**
 * 
 * @export
 * @interface SendSessionApplicationAcceptedOutput
 */
export interface SendSessionApplicationAcceptedOutput {
    /**
     * List of user IDs that were successfully notified of session application acceptance
     * @type {any}
     * @memberof SendSessionApplicationAcceptedOutput
     */
    'users_notified': any;
    /**
     * List of user IDs that failed to receive session application accepted notification
     * @type {any}
     * @memberof SendSessionApplicationAcceptedOutput
     */
    'failed_users'?: any;
    /**
     * Status message about the session application accepted notification process
     * @type {any}
     * @memberof SendSessionApplicationAcceptedOutput
     */
    'message': any;
}
/**
 * 
 * @export
 * @interface SendSpeakerGramInput
 */
export interface SendSpeakerGramInput {
    /**
     * List of user IDs to send speaker gram notification to
     * @type {any}
     * @memberof SendSpeakerGramInput
     */
    'user_ids': any;
    /**
     * Slug of the session for the speaker gram
     * @type {any}
     * @memberof SendSpeakerGramInput
     */
    'slug': any;
}
/**
 * 
 * @export
 * @interface SendSpeakerGramOutput
 */
export interface SendSpeakerGramOutput {
    /**
     * List of user IDs that were successfully notified of speaker gram
     * @type {any}
     * @memberof SendSpeakerGramOutput
     */
    'users_notified': any;
    /**
     * List of user IDs that failed to receive the speaker gram notification
     * @type {any}
     * @memberof SendSpeakerGramOutput
     */
    'failed_users'?: any;
    /**
     * Status message about the speaker gram notification process
     * @type {any}
     * @memberof SendSpeakerGramOutput
     */
    'message': any;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {any}
     * @memberof ValidationError
     */
    'loc': any;
    /**
     * 
     * @type {any}
     * @memberof ValidationError
     */
    'msg': any;
    /**
     * 
     * @type {any}
     * @memberof ValidationError
     */
    'type': any;
}

/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send session application accepted notification to users via CustomerIO.  This endpoint uses CQRS pattern: 1. Creates a SendSessionApplicationAccepted command 2. Executes via MessageBus with command handler 3. Returns the result from the command handler
         * @summary Send Session Application Accepted
         * @param {SendSessionApplicationAcceptedInput} sendSessionApplicationAcceptedInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost: async (sendSessionApplicationAcceptedInput: SendSessionApplicationAcceptedInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendSessionApplicationAcceptedInput' is not null or undefined
            assertParamExists('sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost', 'sendSessionApplicationAcceptedInput', sendSessionApplicationAcceptedInput)
            const localVarPath = `/events/send-session-application-accepted/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendSessionApplicationAcceptedInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send Speaker Gram notification to users via CustomerIO.  This endpoint uses CQRS pattern: 1. Creates a SendSpeakerGram command 2. Executes via MessageBus with command handler 3. Returns the result from the command handler
         * @summary Send Speaker Gram
         * @param {SendSpeakerGramInput} sendSpeakerGramInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSpeakerGramEventsSendSpeakerGramPost: async (sendSpeakerGramInput: SendSpeakerGramInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendSpeakerGramInput' is not null or undefined
            assertParamExists('sendSpeakerGramEventsSendSpeakerGramPost', 'sendSpeakerGramInput', sendSpeakerGramInput)
            const localVarPath = `/events/send-speaker-gram/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendSpeakerGramInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * Send session application accepted notification to users via CustomerIO.  This endpoint uses CQRS pattern: 1. Creates a SendSessionApplicationAccepted command 2. Executes via MessageBus with command handler 3. Returns the result from the command handler
         * @summary Send Session Application Accepted
         * @param {SendSessionApplicationAcceptedInput} sendSessionApplicationAcceptedInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost(sendSessionApplicationAcceptedInput: SendSessionApplicationAcceptedInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendSessionApplicationAcceptedOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost(sendSessionApplicationAcceptedInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Send Speaker Gram notification to users via CustomerIO.  This endpoint uses CQRS pattern: 1. Creates a SendSpeakerGram command 2. Executes via MessageBus with command handler 3. Returns the result from the command handler
         * @summary Send Speaker Gram
         * @param {SendSpeakerGramInput} sendSpeakerGramInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSpeakerGramEventsSendSpeakerGramPost(sendSpeakerGramInput: SendSpeakerGramInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendSpeakerGramOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSpeakerGramEventsSendSpeakerGramPost(sendSpeakerGramInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.sendSpeakerGramEventsSendSpeakerGramPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * Send session application accepted notification to users via CustomerIO.  This endpoint uses CQRS pattern: 1. Creates a SendSessionApplicationAccepted command 2. Executes via MessageBus with command handler 3. Returns the result from the command handler
         * @summary Send Session Application Accepted
         * @param {EventsApiSendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost(requestParameters: EventsApiSendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendSessionApplicationAcceptedOutput> {
            return localVarFp.sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost(requestParameters.sendSessionApplicationAcceptedInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Send Speaker Gram notification to users via CustomerIO.  This endpoint uses CQRS pattern: 1. Creates a SendSpeakerGram command 2. Executes via MessageBus with command handler 3. Returns the result from the command handler
         * @summary Send Speaker Gram
         * @param {EventsApiSendSpeakerGramEventsSendSpeakerGramPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSpeakerGramEventsSendSpeakerGramPost(requestParameters: EventsApiSendSpeakerGramEventsSendSpeakerGramPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendSpeakerGramOutput> {
            return localVarFp.sendSpeakerGramEventsSendSpeakerGramPost(requestParameters.sendSpeakerGramInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost operation in EventsApi.
 * @export
 * @interface EventsApiSendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPostRequest
 */
export interface EventsApiSendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPostRequest {
    /**
     * 
     * @type {SendSessionApplicationAcceptedInput}
     * @memberof EventsApiSendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost
     */
    readonly sendSessionApplicationAcceptedInput: SendSessionApplicationAcceptedInput
}

/**
 * Request parameters for sendSpeakerGramEventsSendSpeakerGramPost operation in EventsApi.
 * @export
 * @interface EventsApiSendSpeakerGramEventsSendSpeakerGramPostRequest
 */
export interface EventsApiSendSpeakerGramEventsSendSpeakerGramPostRequest {
    /**
     * 
     * @type {SendSpeakerGramInput}
     * @memberof EventsApiSendSpeakerGramEventsSendSpeakerGramPost
     */
    readonly sendSpeakerGramInput: SendSpeakerGramInput
}

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * Send session application accepted notification to users via CustomerIO.  This endpoint uses CQRS pattern: 1. Creates a SendSessionApplicationAccepted command 2. Executes via MessageBus with command handler 3. Returns the result from the command handler
     * @summary Send Session Application Accepted
     * @param {EventsApiSendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost(requestParameters: EventsApiSendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost(requestParameters.sendSessionApplicationAcceptedInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send Speaker Gram notification to users via CustomerIO.  This endpoint uses CQRS pattern: 1. Creates a SendSpeakerGram command 2. Executes via MessageBus with command handler 3. Returns the result from the command handler
     * @summary Send Speaker Gram
     * @param {EventsApiSendSpeakerGramEventsSendSpeakerGramPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public sendSpeakerGramEventsSendSpeakerGramPost(requestParameters: EventsApiSendSpeakerGramEventsSendSpeakerGramPostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).sendSpeakerGramEventsSendSpeakerGramPost(requestParameters.sendSpeakerGramInput, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckHealthGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckHealthGet(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SystemApi.healthCheckHealthGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * Health check endpoint for AWS load balancers and monitoring
         * @summary Health Check
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthCheckHealthGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
    /**
     * Health check endpoint for AWS load balancers and monitoring
     * @summary Health Check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    public healthCheckHealthGet(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).healthCheckHealthGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebsocketsApi - axios parameter creator
 * @export
 */
export const WebsocketsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Connect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectWebsocketsConnectPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/websockets/connect/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disconnect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectWebsocketsDisconnectPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/websockets/disconnect/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebsocketsApi - functional programming interface
 * @export
 */
export const WebsocketsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebsocketsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Connect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectWebsocketsConnectPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectWebsocketsConnectPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WebsocketsApi.connectWebsocketsConnectPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Disconnect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectWebsocketsDisconnectPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectWebsocketsDisconnectPost(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['WebsocketsApi.disconnectWebsocketsDisconnectPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * WebsocketsApi - factory interface
 * @export
 */
export const WebsocketsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebsocketsApiFp(configuration)
    return {
        /**
         * 
         * @summary Connect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectWebsocketsConnectPost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.connectWebsocketsConnectPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disconnect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectWebsocketsDisconnectPost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.disconnectWebsocketsDisconnectPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebsocketsApi - object-oriented interface
 * @export
 * @class WebsocketsApi
 * @extends {BaseAPI}
 */
export class WebsocketsApi extends BaseAPI {
    /**
     * 
     * @summary Connect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebsocketsApi
     */
    public connectWebsocketsConnectPost(options?: RawAxiosRequestConfig) {
        return WebsocketsApiFp(this.configuration).connectWebsocketsConnectPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disconnect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebsocketsApi
     */
    public disconnectWebsocketsDisconnectPost(options?: RawAxiosRequestConfig) {
        return WebsocketsApiFp(this.configuration).disconnectWebsocketsDisconnectPost(options).then((request) => request(this.axios, this.basePath));
    }
}



